export default "__VITE_ASSET__B7yjTp0W__"